// Data-rich screens register what they are showing so each chat message can
// carry it along (see useCodexChat.currentScreenContext). Module-level on
// purpose: the rail lives outside the route tree.
export interface ScreenData {
  kind: 'report' | 'pivot' | 'grants'
  id: string
  title: string
  from?: string
  to?: string
  rows: unknown[]
}

// Registrations only count while the user is still in the section that made
// them: reports clear on unmount, the pivot fetch layer has no unmount, so
// leaving /pivot simply stops matching.
const SCOPE: Record<ScreenData['kind'], string> = { report: '/report', pivot: '/pivot', grants: '/bandi' }

let current: ScreenData | null = null

export const setScreenData = (value: ScreenData | null) => {
  current = value
}

export const getScreenData = (pathname: string) =>
  current && pathname.startsWith(SCOPE[current.kind]) ? current : null
